
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"20","height":"20","rx":"4","fill":"#7B01B5"}}),_c('path',{attrs:{"d":"M4.833 6.667a.833.833 0 010-1.667h10.334a.833.833 0 010 1.667H4.833zM4 10c0 .46.373.833.833.833h10.334a.833.833 0 000-1.666H4.833A.833.833 0 004 10zM4 14.167c0 .46.373.833.833.833h10.334a.833.833 0 000-1.667H4.833a.833.833 0 00-.833.834z","fill":"#fff"}})])
          )
        }
      }
    